import { Project } from "./types";

// Helper to create dates starting from Jan 1st 2026 (or current year)
const getDate = (day: number) => {
  const date = new Date();
  date.setFullYear(2025, 0, day); // Jan = 0
  return date.getTime();
};

// REPLACE THIS WITH YOUR ACTUAL CHANNEL ID OR HANDLE
export const YOUTUBE_CHANNEL_ID = '@365Jurney'; 

export const INITIAL_PROJECTS: Project[] = [
  {
    id: '1',
    title: 'Devfolio AI',
    description: 'An AI-powered portfolio generator.',
    url: 'https://devfolioai.iqodex.workers.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=1',
    tags: ['AI', 'Portfolio', 'React'],
    category: 'Web App',
    createdAt: getDate(1),
    views: 0
  },
  {
    id: '2',
    title: 'HexVibe',
    description: 'A vibrant color palette generator.',
    url: 'https://hexvibe.iqodex.workers.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=2',
    tags: ['Design', 'Colors', 'Tool'],
    category: '3D/Creative',
    createdAt: getDate(2),
    views: 0
  },
  {
    id: '3',
    title: 'Markdown Live',
    description: 'Real-time markdown editor.',
    url: 'https://markdown.iqodex.workers.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=3',
    tags: ['Markdown', 'Editor', 'Utility'],
    category: 'Utility',
    createdAt: getDate(3),
    views: 0
  },
  {
    id: '4',
    title: 'LinkCard',
    description: 'A centralized link-in-bio page.',
    url: 'https://linkcard.iqodex.workers.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=4',
    tags: ['Social', 'Profile', 'Bio'],
    category: 'Web App',
    createdAt: getDate(4),
    views: 0
  },
  {
    id: '5',
    title: 'FlashMind',
    description: 'Interactive flashcards application.',
    url: 'https://flashmind.iqodex.workers.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=5',
    tags: ['Education', 'Learning', 'React'],
    category: 'Web App',
    createdAt: getDate(5),
    views: 0
  },
  {
    id: '6',
    title: 'BodyMetrics AI',
    description: 'Health tracking dashboard.',
    url: 'https://bodymetrics-ai.iqodex.workers.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=6',
    tags: ['Health', 'Data', 'Dashboard'],
    category: 'Web App',
    createdAt: getDate(6),
    views: 0
  },
  {
    id: '7',
    title: 'NeonPulse',
    description: 'A visually striking creative landing page.',
    url: 'https://neonpulse.iqodex.workers.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=7',
    tags: ['Creative', 'Animation', 'Design'],
    category: '3D/Creative',
    createdAt: getDate(7),
    views: 0
  },
  {
    id: '8',
    title: 'Bin8 Converter',
    description: 'Efficient binary to decimal converter tool.',
    url: 'https://bin8-iqodex.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=8',
    tags: ['Utility', 'Math', 'Converter'],
    category: 'Utility',
    createdAt: getDate(8),
    views: 0
  },
  {
    id: '9',
    title: 'MorphRadius',
    description: 'Visual CSS border-radius generator.',
    url: 'https://morphradius.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=9',
    tags: ['CSS', 'Frontend', 'Design'],
    category: 'Frontend',
    createdAt: getDate(9),
    views: 0
  },
  {
    id: '10',
    title: 'Splitter',
    description: 'A bill splitting application.',
    url: 'https://splitter-57w.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=10',
    tags: ['Finance', 'Utility', 'Calculator'],
    category: 'Utility',
    createdAt: getDate(10),
    views: 0
  },
  {
    id: '11',
    title: 'Jokr',
    description: 'Instant joke generator.',
    url: 'https://jokr.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=11',
    tags: ['Fun', 'API', 'Entertainment'],
    category: 'Web App',
    createdAt: getDate(11),
    views: 0
  },
  {
    id: '12',
    title: 'WordSmith',
    description: 'Dictionary and thesaurus tool.',
    url: 'https://wordsmith-id.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=12',
    tags: ['Dictionary', 'API', 'Words'],
    category: 'Utility',
    createdAt: getDate(12),
    views: 0
  },
  {
    id: '13',
    title: 'Set Game',
    description: 'Digital implementation of the classic game.',
    url: 'https://set-id.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=13',
    tags: ['Game', 'Logic', 'React'],
    category: 'Web App',
    createdAt: getDate(13),
    views: 0
  },
  {
    id: '14',
    title: 'PQW Generator',
    description: 'Secure password generator.',
    url: 'https://pqw.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=14',
    tags: ['Security', 'Utility', 'Tools'],
    category: 'Utility',
    createdAt: getDate(14),
    views: 0
  },
  {
    id: '15',
    title: 'ChronoFlow',
    description: 'Productivity timer leveraging Pomodoro.',
    url: 'https://chronoflow-id.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=15',
    tags: ['Productivity', 'Timer', 'Time'],
    category: 'Utility',
    createdAt: getDate(15),
    views: 0
  },
  {
    id: '16',
    title: 'TaskFlow Prioritizer',
    description: 'Task management app by urgency.',
    url: 'https://taskflow-prioritizer.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=16',
    tags: ['Productivity', 'Tasks', 'Organization'],
    category: 'Full-Stack',
    createdAt: getDate(16),
    views: 0
  },
  {
    id: '17',
    title: 'SparkQuiz',
    description: 'Dynamic quiz platform.',
    url: 'https://sparkquiz.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=17',
    tags: ['Quiz', 'Education', 'Fun'],
    category: 'Web App',
    createdAt: getDate(17),
    views: 0
  },
  {
    id: '18',
    title: 'PaterGen',
    description: 'CSS background pattern generator.',
    url: 'https://patergen.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=18',
    tags: ['CSS', 'Design', 'Generator'],
    category: '3D/Creative',
    createdAt: getDate(18),
    views: 0
  },
  {
    id: '19',
    title: 'Precision Converter',
    description: 'Multi-purpose unit converter.',
    url: 'https://precision-unit-converter.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=19',
    tags: ['Utility', 'Math', 'Tools'],
    category: 'Utility',
    createdAt: getDate(19),
    views: 0
  },
  {
    id: '20',
    title: 'Stopwatch Pro',
    description: 'Accurate stopwatch with laps.',
    url: 'https://stopwatch-id.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=20',
    tags: ['Time', 'Utility', 'Sports'],
    category: 'Utility',
    createdAt: getDate(20),
    views: 0
  },
  {
    id: '21',
    title: 'MoodFlow',
    description: 'Daily mood tracker calendar.',
    url: 'https://moodflow-calendar.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=21',
    tags: ['Health', 'Tracking', 'Calendar'],
    category: 'Web App',
    createdAt: getDate(21),
    views: 0
  },
  {
    id: '22',
    title: 'Sentinel Dashboard',
    description: 'Admin dashboard template.',
    url: 'https://sentinel-id.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=22',
    tags: ['Dashboard', 'Admin', 'UI'],
    category: 'Frontend',
    createdAt: getDate(22),
    views: 0
  },
  {
    id: '23',
    title: 'SocialPolls',
    description: 'Platform to create and share polls.',
    url: 'https://socialpolls-id.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=23',
    tags: ['Social', 'Interaction', 'Full-Stack'],
    category: 'Full-Stack',
    createdAt: getDate(23),
    views: 0
  },
  {
    id: '24',
    title: 'RecipeCM',
    description: 'Digital cookbook for recipes.',
    url: 'https://recipecm.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=24',
    tags: ['Food', 'Lifestyle', 'Database'],
    category: 'Web App',
    createdAt: getDate(24),
    views: 0
  },
  {
    id: '25',
    title: 'TabUI',
    description: 'Accessible and animated tabs.',
    url: 'https://tabui.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=25',
    tags: ['UI', 'Components', 'Accessibility'],
    category: 'Frontend',
    createdAt: getDate(25),
    views: 0
  },
  {
    id: '26',
    title: 'VowelCounter',
    description: 'Simple text analysis tool.',
    url: 'https://vowelcounter.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=26',
    tags: ['Text', 'Analysis', 'Beginner'],
    category: 'Utility',
    createdAt: getDate(26),
    views: 0
  },
  {
    id: '27',
    title: 'ChromaGen',
    description: 'Abstract art generator.',
    url: 'https://chromagen.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=27',
    tags: ['Art', 'Canvas', 'Generative'],
    category: '3D/Creative',
    createdAt: getDate(27),
    views: 0
  },
  {
    id: '28',
    title: 'RPS Master',
    description: 'Classic Rock Paper Scissors game vs AI.',
    url: 'https://rpsmaster.pages.dev/',
    thumbnailUrl: 'https://picsum.photos/600/400?random=28',
    tags: ['Game', 'Logic', 'Fun'],
    category: 'Web App',
    createdAt: getDate(28),
    views: 0
  }
];
